import React from "react";
import CompositionContent from "./composition-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import {formatAnimals, formatArrayString, formatBoolean, formatSectors, intendedFunctionValue, translatedLabel, ignoredLabels, outputOrder} from "../utils/garrison-audit-utils.js";

const CreateContent = ({element, animals, garrisonLeader}) => {
    const createData = JSON.parse(element?.newjson ?? "{}");
    const valueCellClassName = "whitespace-normal break-all";

    const orderedEntries = Object.entries(createData ?? {}).sort(([a], [b]) => {
        const posA = outputOrder.indexOf(a);
        const posB = outputOrder.indexOf(b);

        if (posA === -1 && posB === -1) return 0;
        if (posA === -1) return 1;
        if (posB === -1) return -1;

        return posA - posB;
    });

    return (
        <tr className="create-content-table">
            <td colSpan={14}>
                <table className="applied insider w-full table-fixed">
                    <thead>
                        <tr className="text-left">
                            <th style={{width: "30%"}}>Campo</th>
                            <th style={{width: "70%"}}>Novo</th>
                        </tr>
                    </thead>

                    <tbody>
                        { orderedEntries.map(([key, value], index) => {

                            if (key === "garrison_composition") {
                                return (
                                    <CompositionContent key={index} composition={value} animals={animals}/>
                                );
                            }

                            if (key === "garrison_sectors" || key === "sectors") {
                                return (
                                    <tr key={index} className="table-break-word text-left">
                                        <td>Setor</td>
                                        <td className={valueCellClassName}>{formatSectors(value)}</td>
                                    </tr>
                                );
                            }

                            if (key === "garrison_intendedfunction") {
                                return (
                                    <tr key={index} className="table-break-word text-left">
                                        <td>Função destinada</td>
                                        <td className={valueCellClassName}>{intendedFunctionValue(value)}</td>
                                    </tr>
                                );
                            }

                            if (key === "animals") {
                                return (
                                    <tr key={index} className="table-break-word text-left">
                                        <td>Animais</td>
                                        <td className={valueCellClassName}>{formatAnimals(value, animals)}</td>
                                    </tr>
                                );
                            }

                            if (key === "garrison_leaderid") {
                                const leader = Array.isArray(garrisonLeader) ? garrisonLeader.find(c => Number(c.id) === Number(value)) : null;

                                return (
                                    <tr key={index} className="table-break-word text-left">
                                        <td>Responsável</td>
                                        <td className={valueCellClassName}>{leader?.namewar ?? ""}</td>
                                    </tr>
                                );
                            }

                            if (ignoredLabels.includes(key)) return null;
                            if (!translatedLabel[key]) return null;

                            const tableValue = formatBoolean(formatArrayString(value));
                            const label = translatedLabel[key];

                            return (
                                <tr key={index} className="table-break-word text-left">
                                    <td>{label}</td>
                                    <td className={valueCellClassName}>
                                        {ReportUtils.formatObjectString(tableValue)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default CreateContent;